var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c(_vm.$route.meta.layout ? _vm.$route.meta.layout : _vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"page"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }